import { render, staticRenderFns } from "./UpdateSttusPopUp.vue?vue&type=template&id=e6100cda&"
import script from "./UpdateSttusPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateSttusPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports